// base/pcBase.js
// PC向けの“土台”初期化。SPの spBase.js と思想を揃え、index 側をスッキリさせる。

import { toggleElementsByPosition, toggleHeaderByScrollDirection, resetHeaderScrollBaseline, adjustByHeaderHeight, enableSmoothAnchors, resnapHashAfterInit } from "../core/scroll.js";
import { initMegaNav } from "../features/megaNav.js";

/**
 * PC向け共通初期化
 * - ヘッダー高さのCSS変数反映
 * - アンカーのスムース＆補正（CSSの scroll-margin-top 前提）
 * - メガナビ（PC幅のみ）
 * - SNS/ページトップの表示切替
 */
export function initPcBase({ headerSelector = ".l-header", mvSelector = ".js-mv", menuBgSelector = ".l-header__bg", snsSelector = ".js-sns", pageTopSelector = ".js-page-top", breakpoint = 1025 } = {}) {
  const header = document.querySelector(headerSelector);
  if (!header) return () => {};

  const mvSection = document.querySelector(mvSelector);
  const menuBg = document.querySelector(menuBgSelector);
  const sns = document.querySelector(snsSelector);
  const pageTop = document.querySelector(pageTopSelector);

  // 初期状態（非表示）
  [sns, pageTop].forEach((el) => el?.classList.add("hidden"));
  const elementsToToggle = [
    { element: sns, initialClass: "hidden" },
    { element: pageTop, initialClass: "hidden" },
  ];

  // メガナビ（PCのみ）
  const disposeMegaNav = initMegaNav?.({ breakpoint });

  // アンカー（スムース＆ハッシュ再調整）
  enableSmoothAnchors();
  resnapHashAfterInit();

  // ヘッダー高さ → CSS変数 反映
  adjustByHeaderHeight(header, mvSection, menuBg);
  const onResize = () => adjustByHeaderHeight(header, mvSection, menuBg);
  window.addEventListener("resize", onResize, { passive: true });

  // スクロール制御
  const onScroll = () => {
    toggleElementsByPosition(header, mvSection, elementsToToggle);
    toggleHeaderByScrollDirection(header);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll(); // 初期反映

  // 基準リセット（ハッシュ移動後のズレ軽減）
  const resetBaseline = () => resetHeaderScrollBaseline();
  window.addEventListener("hashchange", resetBaseline);

  // 破棄関数
  return () => {
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", onResize);
    window.removeEventListener("hashchange", resetBaseline);
    disposeMegaNav?.();
  };
}
